"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "mx-auto max-w-[328px] rounded bg-gray-20 px-4 pb-8 pt-6 text-center" };
const BenefitItems_vue_1 = __importDefault(require("@/components/BenefitItems.vue"));
const BottomLoginRegisterToggle_vue_1 = __importDefault(require("@/components/BottomLoginRegisterToggle.vue"));
const BaseFootnote_vue_1 = __importDefault(require("@/components/BaseFootnote.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'BottomContentModal',
    props: {
        items: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(BottomLoginRegisterToggle_vue_1.default, { class: "mb-6" }),
                    (_ctx.items.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BenefitItems_vue_1.default, {
                            key: 0,
                            class: "text-left",
                            items: _ctx.items
                        }, null, 8, ["items"]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createVNode)(BaseFootnote_vue_1.default)
            ], 64));
        };
    }
});
